module.exports = __webpack_public_path__ + "img/22.2840536d.jpg";